module.exports = __webpack_public_path__ + "img/ls_img2.149edb38.png";